import React from 'react';
import { TextInput, StyleSheet } from 'react-native';
import { MaskInputProps, mask } from 'react-native-mask-text';

export const CustomInput = ({
  value,
  onChangeText,
  placeholder,
  secureTextEntry,
  maskType,
  keyboardType = 'default',
  ...props
}) => {
  const handleChangeText = (text) => {
    if (maskType === 'cpf') {
      text = mask(text, '999.999.999-99');
    } else if (maskType === 'phone') {
      text = mask(text, '(99) 99999-9999');
    }
    onChangeText(text);
  };

  return (
    <TextInput
      style={styles.input}
      value={value}
      onChangeText={handleChangeText}
      placeholder={placeholder}
      secureTextEntry={secureTextEntry}
      keyboardType={keyboardType}
      placeholderTextColor="#999"
      {...props}
    />
  );
};

const styles = StyleSheet.create({
  input: {
    width: '100%',
    height: 50,
    backgroundColor: '#FFF',
    borderRadius: 10,
    paddingHorizontal: 15,
    marginBottom: 15,
    fontSize: 16,
    borderWidth: 1,
    borderColor: '#E5E5E5',
  },
});